import React, { useEffect, useState } from 'react'
import "./partRequestItemTask.css"
import { PartRequestItemPart } from '../PartRequestItemPart/PartRequestItemPart';
import HierarchyLines from '../../../../../TestLine/HierarchyLines';
import { getPartRequestTabularInfo } from '../../../Services/partRequestService';
import { environment } from '../../../../../environments/environment';
import { HTTP_RESPONSE_CODES } from '../../../../../globals/globals';
import { Sorting } from '../../../../../components/Lists/Sorting';
import { Tooltip } from '@mui/material';
import { SortingHeader } from '../../../../../components/Sorting/SortingHeader';
import { SortingProvider } from '../../../../../contexts/SortingContext';
import { SortingButton } from '../../../../../components/Sorting/SortingButton';

export const PartRequestItemTask = ({ totalLength, itemTaskOpened, idx, emitItemOpened, initialData, partReqId, PRNStatus }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [partList, setPartList] = useState([])
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(initialData?.part_count ? initialData?.part_count : 20);
    const [order, setOrder] = useState("id");
    const [search, setSearch] = useState("");


    const getPartList = async () => {
        let request = await getPartRequestTabularInfo(page, pageSize, order, search, partReqId)

        if (request.data.responseCode == HTTP_RESPONSE_CODES.SUCCESS) {
            setPartList(() => {
                return [...request.data.load]
            })
        }
    }


    const handlePartsUpsated = () => {
        setPartList([])
        getPartList()
    }
    useEffect(() => {
        if (itemTaskOpened !== idx) {
            setIsOpen(false)
        }
    }, [itemTaskOpened])

    useEffect(() => {
        if (isOpen) {
            getPartList()
        }
    }, [isOpen])

    useEffect(() => { getPartList() }, [order])

    const handleSortingChange = (data) => {
        setOrder(data)
    }

    return (
        <SortingProvider onOrderChange={handleSortingChange}
            properties={{
                part_number: "PN",
                serialized_part_number_selected: "SN",
                internal_batch: "Batch",
                // uom_name: "UOM",
                quantity: "QTY",
                quantity_issue: "Issued QTY",
                remaining_quantity: "Remaining QTY"
            }}>
            <div className='PartRequestItemTask'>
                <section className={`partRequest-itemTask-header ${open ? 'open' : ''}`}
                    style={{
                        background: isOpen ? "#EFFCFF" : "",
                        border: isOpen ? "1px solid #B9D8DF" : "",
                        position: isOpen ? "sticky" : "relative",
                        top: isOpen ? "calc(var(--item-min-height) + .5rem)" : ""
                    }}
                    onClick={() => {
                        setIsOpen(!isOpen)
                        emitItemOpened(idx)
                    }}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            setIsOpen(!isOpen);
                            emitItemOpened(idx);
                        }
                    }}
                    tabIndex={0}
                >
                    <HierarchyLines
                        idx={idx}
                        totalLength={totalLength}
                        initialTop={66}

                    ></HierarchyLines>

                    <span
                        style={{
                            backgroundColor:
                                partList.every(part =>
                                    (part.part_type === "Serialized" && part.serialized_part_id_selected != null) ||
                                    (part.part_type !== "Serialized" && part.quantity <= part.available_quantity)
                                )
                                    ? "var(--green-250)" // every child availability is green
                                    : partList.every(part =>
                                        part.available_quantity === 0 || part.available_quantity === null && part.quantity > 0
                                    )
                                        ? "var(--red-300)" // every child availability is red
                                        : "var(--yellow-100)" // any other case (mixed)
                        }}
                    ></span>
                    <span
                        className='PartRequestItemTask-span-icon-availability'
                        style={{
                            backgroundColor:
                                partList.every(part =>
                                    (part.part_type === "Serialized" && part.serialized_part_id_selected != null) ||
                                    (part.part_type !== "Serialized" && part.quantity <= part.available_quantity)
                                )
                                    ? "var(--green-250)"// every child availability is green
                                    : partList.every(part =>
                                        part.available_quantity === 0 || part.available_quantity === null && part.quantity > 0
                                    )
                                        ? "var(--red-300)" // every child availability is red
                                        : "var(--yellow-100)"// any other case (mixed)
                        }}
                    >

                        <i className={

                            partList.every(part =>
                                (part.part_type === "Serialized" && part.serialized_part_id_selected != null) ||
                                (part.part_type !== "Serialized" && part.quantity <= part.available_quantity)
                            )
                                ? "icon-success" // every child availability is green
                                : partList.every(part =>
                                    part.available_quantity === 0 || part.available_quantity === null && part.quantity > 0
                                )
                                    ? "icon-error" // every child availability is red
                                    : "icon-warning" // any other case (mixed)
                        }></i>
                    </span>
                    <i className='icon-task_icon_partRequest'></i>
                    <p style={{ width: "15%", minWidth: "6rem" }}>
                        {initialData?.reference_type == "Task Card" ? "TC" : "FND"}
                        <Tooltip title={initialData?.reference_id ? initialData.reference_id : "--"} arrow>
                            <span className='ellipsis'>
                                {
                                    initialData?.reference_id ? initialData.reference_id : "--"
                                }
                            </span>
                        </Tooltip>
                    </p>
                    <p style={{ width: "25%", minWidth: "9rem" }}>Description
                        <Tooltip title={initialData?.reference_description ? initialData.reference_description : "--"}>
                            <span className='ellipsis'>
                                {
                                    initialData?.reference_description ? initialData.reference_description : "--"
                                }
                            </span>
                        </Tooltip>
                    </p>
                    <Tooltip title={initialData?.part_count ? initialData.part_count : "--"} arrow>
                        <p style={{ width: "5%", minWidth: "1rem" }}>PN<span
                            style={{
                                backgroundColor: "#404041",
                                // height: "1rem",
                                // width: "1rem",
                                minWidth: "1rem",
                                borderRadius: ".2rem",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "var(--white)",
                                fontSize: "var(--p-size)",
                                padding: "0.1rem 0.2rem"

                            }}
                        >{initialData?.part_count ? initialData.part_count : "--"}</span>
                        </p>
                    </Tooltip>
                    <section>
                        {/* 2024-08-25 */}
                        <i style={{
                            transition: "var(--transition)",
                            transform: isOpen ? "rotate(180deg)" : ""
                        }} className='icon-arrow-down'></i>
                    </section>
                </section>
                <section className={`PartRequest-ItemTask-content ${isOpen ? 'open' : ''}`}>
                    {/* <HierarchyLines
                    idx={idx}
                    totalLength={totalLength}
                    initialTop={60}
                    zIndex={5}

                ></HierarchyLines> */}
                    <section className='sorting-sticky'>
                        {/* <HierarchyLines
                        idx={-1}
                        totalLength={totalLength}
                        initialTop={10}
                        noChild={false}
                        depth={1}
                    ></HierarchyLines> */}
                        <SortingHeader
                            showHeaderOrder={true}

                        />
                        {/* <SortingButton></SortingButton> */}
                    </section>
                    <section className='PNList-and-sorting-cont'>


                        <div className='PNList-cont'>
                            {isOpen && partList.map((part, idx) => (
                                <PartRequestItemPart
                                    key={idx}
                                    initialData={part}
                                    prnStatus={PRNStatus}
                                    reloadParentList={handlePartsUpsated}
                                />
                            ))}
                        </div>
                    </section>


                </section>
            </div >
        </SortingProvider>
    )
}
